import { createSvgIcon } from '@mui/material';

export const ExamHexagon = createSvgIcon(
  <path d="M20,16.11a1.1,1.1,0,0,1-.59,1L10.63,22a1.09,1.09,0,0,1-1.26,0L.59,17.09a1.1,1.1,0,0,1-.59-1v-10a1.1,1.1,0,0,1,.59-1L9.37.2a1.09,1.09,0,0,1,1.26,0l8.78,4.93a1.1,1.1,0,0,1,.59,1Z" />,
  'ExamHexagon',
);
// @ts-expect-error MUI type definitions kind of suck
ExamHexagon.defaultProps = { color: 'action' };
